export default __webpack_public_path__ + "static/media/logotipo_tradicional_sacola_44.590be792.png";